import {
  AdminPanelActions,
  GET_ALL_COMPANIES_SUCCESS,
  GET_ALL_PRODUCTS_FAILED,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_NON_LICENSED_SOLUTIONS_FAILED,
  GET_NON_LICENSED_SOLUTIONS_SUCCESS,
  GetAllCompaniesSuccessAction,
  GetAllProductsSuccessAction,
  GetNonLicensedSolutionsSuccessAction,
  GET_USER_DETAIL,
  GET_USER_DETAIL_SUCCESS,
  GetUserDetailSuccessAction,
  GET_COMPANY_DETAIL_SUCCESS,
  GetCompanyDetailSuccessAction, GET_COMPANY_DETAIL, GET_USER_NOTE, GET_USER_NOTE_SUCCESS, GetUserNoteSuccessAction,
  ADD_SOLUTION_SUCCESS
} from '../actions/admin-panel.action';
import {ProductModel} from '../../models/product.model';
import {UserModel} from '../../models/user.model';
import {CompanyModel} from '../../models/company.model';
import {PagedResponse} from '@shared/models/paged-response-model';
import {FieldSection} from '@shared/models/field-section';
import {PageInfo} from '@shared/models/page-info';

export interface AdminPanelState {
  pagedResponse: PagedResponse;
  fieldSections: FieldSection[];
  pageInfo: PageInfo;
  selectedItems: any[];
  avatars: any;
  selectedUser: UserModel;
  products: ProductModel[];
  solutions: any[];
  selectedCompany: CompanyModel;
  companies: CompanyModel[];
  selectedUserNote: any;
  userDetailSelectedTab: number;
}

export const initialState = <AdminPanelState>{
  pagedResponse: <PagedResponse>{
    items: [],
    pageNo: 0,
    pageSize: 10
  },
  fieldSections: [],
  pageInfo: {
    pageCount: 0,
    pageNo: 0,
    pageSize: 10,
    recordCount: 0
  },
  selectedItems: [],
  avatars: {},
  selectedUser: null,
  products: [],
  solutions: [],
  selectedCompany: null,
  companies: [],
  selectedUserNote: null,
  userDetailSelectedTab: 0
};

export function adminPanelReducer(state: AdminPanelState = initialState, action: AdminPanelActions) {
  switch (action.type) {
    case GET_ALL_PRODUCTS_FAILED: {
      return {...state, products: []};
    }
    case GET_ALL_PRODUCTS_SUCCESS: {
      return {...state, products: (action as GetAllProductsSuccessAction).payload};
    }
    case GET_NON_LICENSED_SOLUTIONS_FAILED: {
      return {...state, solutions: []};
    }
    case GET_NON_LICENSED_SOLUTIONS_SUCCESS: {
      return {...state, solutions: (action as GetNonLicensedSolutionsSuccessAction).payload};
    }
    case GET_ALL_COMPANIES_SUCCESS: {
      return {...state, companies: (action as GetAllCompaniesSuccessAction).payload};
    }
    case GET_USER_DETAIL: {
      return {...state, selectedUser: null};
    }
    case GET_USER_DETAIL_SUCCESS: {
      return {...state, selectedUser: (action as GetUserDetailSuccessAction).payload};
    }
    case GET_COMPANY_DETAIL: {
      return {...state, selectedCompany: null};
    }
    case GET_COMPANY_DETAIL_SUCCESS: {
      return {...state, selectedCompany: (action as GetCompanyDetailSuccessAction).payload};
    }
    case GET_USER_NOTE: {
      return {...state, selectedUserNote: null};
    }
    case GET_USER_NOTE_SUCCESS: {
      return {...state, selectedUserNote: (action as GetUserNoteSuccessAction).payload};
    }
    case ADD_SOLUTION_SUCCESS: {
      return {...state, userDetailSelectedTab: 1};
    }
  }
  return state;
}
